module.exports = __webpack_public_path__ + "media/images/hatena-4da23d436ed7cc63d0de1968e25b7698.svg";